var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 180,
    viewBox: "0 0 1920 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1920 0L1840 30C1760 60 1600 120 1440 144C1280 168 1120 156 960 126C800 96 640 48 480 54C320 60 160 120 80 150L0 180H80C160 180 320 180 480 180C640 180 800 180 960 180C1120 180 1280 180 1440 180C1600 180 1760 180 1840 180H1920V0Z",
    fill: "#FFE8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow);
export default __webpack_public_path__ + "static/media/shadow.2175a95a08b92bc8bd4880ee0effb417.svg";
export { ForwardRef as ReactComponent };